export const removePrefix = (str: string, prefix: string): string => {
  const hasPrefix = str.indexOf(prefix) === 0;
  return hasPrefix ? str.substr(prefix.length) : str;
};
